import React, { useState } from "react";
import PropTypes from "prop-types";
import { Heart } from "lucide-react";

import Button from "./Button";
import { cn } from "../../utils/classNames";
import { getWatchlistToggleLabel } from "../../utils/watchlist";

const WatchlistHeartButton = ({
  show,
  inWatchlist = false,
  onToggle,
  className = "",
}) => {
  const [pulse, setPulse] = useState(false);
  const title = typeof show?.title === "string" && show.title.trim() ? show.title.trim() : "show";

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onToggle?.(show);
    if (!inWatchlist) {
      setPulse(true);
      setTimeout(() => setPulse(false), 300);
    }
  };

  return (
    <Button
      type="button"
      size="icon"
      variant="ghost"
      onClick={handleClick}
      className={cn("sp-card-icon-action", inWatchlist && "sp-card-icon-action--active", className)}
      aria-label={getWatchlistToggleLabel(title)}
      aria-pressed={inWatchlist}
    >
      <Heart
        className={cn("h-4 w-4", inWatchlist && "fill-current text-primary", pulse && "watchlist-pulse")}
        aria-hidden="true"
      />
    </Button>
  );
};

WatchlistHeartButton.propTypes = {
  show: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
  inWatchlist: PropTypes.bool,
  onToggle: PropTypes.func,
  className: PropTypes.string,
};

export default WatchlistHeartButton;
